export const breakpoints = ['0rem', '37.5rem', '62rem'];

export const space = {
    none: '0', // 0px
    xxxs: '0.285rem', // 4px
    xxs: '0.571rem', // 8px
    xs: '0.857rem', // 12px
    sm: '1.142rem', // 16px
    md: '1.714rem', // 24px
    lg: '2.5rem', // 32px
    xl: '3.428rem', // 48px
    xxl: '6.857rem', // 86px
};

export const fontSizes = [
    '0.5rem',
    '0.85rem',
    '1rem',
    '1.5rem',
    '1.8rem',
    '2rem',
];

export const buttonSizes = {
    medium: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingRight: 16,
        paddingLeft: 16,
        borderRadius: 16,
    },
    small: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingRight: 16,
        paddingLeft: 16,
        borderRadius: 16,
    },
};

export const radii = {
    none: '0',
    sm: '0.285rem',
    md: '2.25rem',
    lg: '1.142rem',
    xl: '1.714rem',
};
